<template lang="html">
  <div class="empty-state-container d-table">
    <a
      class="empty-state text-center d-table-cell align-middle"
      @mouseenter="toggleHover"
      @mouseleave="toggleHover"
    >
      <HangerIcon
        width="124px"
        height="124px"
        :active="hovering"
        class="mb-4"
      />
      <h3 class="align-middle primary">Nothing here yet...</h3>
      <p class="lead secondary mt-4">
        You don't have any items under <strong>{{layerDisplayName}}</strong>
      </p>
    </a>
  </div>
</template>

<script>
import HangerIcon from "@/components/wardrobe/icons/Hanger";

export default {
  components: {
    HangerIcon,
  },

  data() {
    return {
      hovering: false,
    };
  },

  props: {
    layerDisplayName: {
      type: String,
      required: false,
    },
  },

  methods: {
    toggleHover() {
      this.hovering = !this.hovering;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.empty-state-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-bottom: 15px;
}

.empty-state {
  cursor: pointer;
  font-weight: 300;
  text-decoration: none;
  color: #a9a9a9;

  .primary,
  .secondary {
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/modals/addProductModal/WardrobeEmptyState.vue